const roleMapping: { [key: string]: number } = {
  unauthorized: 0,
  guest: 1,
  user: 2,
  admin: 3,
};

export default roleMapping;
